import styled from 'styled-components';
import { CgArrowsExpandRight } from 'react-icons/cg';
import Button from '../Button';
import { BsCardImage } from 'react-icons/bs';
import { primaryColor } from '../../config/colors';

export const ImageViewerWrapper = styled.div``;

export const ImageAndFullScreenWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  position: relative;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const FullScreenBtn = styled(Button).attrs({
  wrapperStyle: {
    width: '30px',
    height: '30px',
    marginTop: '10px',
    marginRight: '15px',
    position: 'absolute',
  },
  type: 'rounded',
  icon: CgArrowsExpandRight,
  iconProps: {
    color: 'white',
    size: '18px',
  },
})``;

export const PuffLoaderContainer = styled.div`
  width: ${(props) => props.containerStyle?.width};
  height: ${(props) => props.containerStyle?.height};
  background-color: white;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const ImagePlaceholder = styled(BsCardImage)`
  color: ${primaryColor};
  align-self: center;
  width: 100%;
  height: 100%;
`;
